const isAndroid = (userAgent: string): boolean => userAgent.includes('Android')

const isIpad = (userAgent: string): boolean =>
  userAgent.includes('iPad') ||
  (userAgent.includes('Macintosh') && navigator.maxTouchPoints > 1)

const isIOS = (userAgent: string): boolean =>
  userAgent.includes('iPhone') ||
  userAgent.includes('iPod') ||
  isIpad(userAgent)


export const detectPlatform = (): 'android' | 'ios' | 'other' => {
  const userAgent: string = navigator.userAgent

  if (isAndroid(userAgent)) {
    return 'android'
  } else if (isIOS(userAgent)) {
    return 'ios'
  }

  return 'other'
}
